module.exports = __webpack_public_path__ + "static/img/customerService.94727608.jpg";